import { heroImage, heroStats, heroQuickLinks } from "@/mocks/manga";

export default function Hero() {
  return (
    <section id="top" className="relative w-full">
      <div className="absolute inset-0 w-full h-full">
        <img
          src={heroImage}
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-foreground-950/85 via-foreground-950/70 to-primary-950/70"></div>
      </div>

      <div className="relative w-full px-4 md:px-8 pt-28 md:pt-32 pb-16 md:pb-24">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          <div className="animate-fade-up">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/15 border border-background-50/25 text-background-50 text-xs md:text-sm font-label">
              <i className="ri-award-line text-accent-300" aria-hidden="true"></i>
              包子漫画 · 人气榜单与分类新番
            </span>

            <h1 className="mt-5 font-heading text-3xl md:text-5xl lg:text-[3.25rem] font-black leading-tight text-background-50">
              好看的漫画不用翻找，
              <br className="hidden sm:block" />
              在<span className="text-primary-300">包子漫画排行榜</span>一眼看全
            </h1>

            <p className="mt-5 text-sm md:text-base leading-relaxed text-background-100/90 max-w-xl">
              这里汇集实时更新的人气榜与分类新番，用评分、题材和一句直觉式简介，
              帮你判断哪些是真正好看的漫画。无论你是在追更，还是想从头补番，
              都能在几分钟内锁定下一部要看的作品，省去漫无目的地翻找。
            </p>

            <div className="mt-7 flex flex-wrap gap-3">
              {heroQuickLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-md text-sm font-label font-medium transition-colors whitespace-nowrap cursor-pointer ${
                    link.href === "#ranking"
                      ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                      : "bg-background-50/10 border border-background-50/30 text-background-50 hover:bg-background-50/20"
                  }`}
                >
                  <i className={`${link.icon} text-base`} aria-hidden="true"></i>
                  {link.label}
                </a>
              ))}
            </div>

            <dl className="mt-9 grid grid-cols-3 gap-4 max-w-lg">
              {heroStats.map((stat) => (
                <div key={stat.label} className="border-l-2 border-accent-400/70 pl-3">
                  <dt className="font-heading text-xl md:text-2xl font-bold text-background-50">
                    {stat.value}
                  </dt>
                  <dd className="mt-1 text-xs md:text-sm text-background-100/80">
                    {stat.label}
                  </dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="hidden lg:flex justify-end animate-floaty">
            <div className="w-full max-w-md rounded-lg bg-background-50/95 border border-background-200 p-6">
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 rounded-md bg-secondary-100 text-secondary-700 flex items-center justify-center">
                  <i className="ri-calendar-check-line text-base" aria-hidden="true"></i>
                </span>
                <h2 className="font-heading text-base font-bold text-foreground-950">
                  本周更新速览
                </h2>
              </div>
              <ul className="mt-4 flex flex-col divide-y divide-background-200">
                <li className="flex items-center justify-between py-2.5">
                  <span className="text-sm text-foreground-800">雾港谜案 · 第 30 话</span>
                  <span className="text-xs font-label text-primary-600">周五更新</span>
                </li>
                <li className="flex items-center justify-between py-2.5">
                  <span className="text-sm text-foreground-800">铁拳黎明 · 第 43 话</span>
                  <span className="text-xs font-label text-primary-600">周五更新</span>
                </li>
                <li className="flex items-center justify-between py-2.5">
                  <span className="text-sm text-foreground-800">心跳距离 · 第 25 话</span>
                  <span className="text-xs font-label text-primary-600">周六更新</span>
                </li>
                <li className="flex items-center justify-between py-2.5">
                  <span className="text-sm text-foreground-800">烽火少年志 · 第 28 话</span>
                  <span className="text-xs font-label text-primary-600">周日更新</span>
                </li>
              </ul>
              <a
                href="#schedule"
                className="mt-4 flex items-center justify-center gap-1.5 w-full py-2.5 rounded-md border border-background-300 text-sm font-label text-foreground-800 hover:bg-background-100 transition-colors cursor-pointer"
              >
                查看完整更新日历
                <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}